var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5542 6.73905L7.17123 2.83405C6.78123 2.38405 6.06623 2.38605 5.61323 2.84005L2.83123 5.62705C2.00323 6.45605 1.76623 7.68705 2.24523 8.67405C5.10685 14.599 9.88528 19.3841 15.8062 22.2541C16.7922 22.7331 18.0222 22.4961 18.8502 21.6671L21.6582 18.8541C22.1132 18.3991 22.1142 17.6801 21.6602 17.2901L17.7402 13.9251C17.3302 13.5731 16.6932 13.6191 16.2822 14.0311L14.9182 15.3971C14.8484 15.4702 14.7565 15.5185 14.6566 15.5344C14.5567 15.5503 14.4543 15.5329 14.3652 15.4851C12.1357 14.2012 10.2862 12.3493 9.00523 10.1181C8.95726 10.0288 8.93989 9.92628 8.95578 9.82621C8.97168 9.72614 9.01996 9.63404 9.09323 9.56405L10.4532 8.20305C10.8652 7.78905 10.9102 7.14905 10.5542 6.73805V6.73905Z",
    stroke: "url(#paint0_linear_5796_3278)",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5796_3278",
    x1: -34.3657,
    y1: -26.5652,
    x2: 39.3336,
    y2: -39.7653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.297847,
    stopColor: "#009BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634591,
    stopColor: "#BC658D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.39be5c65ea5ab7306f15311b1b7201bf.svg";
export { ForwardRef as ReactComponent };